import LogoMacRODesignNegative from '../../../app/images/logo_negativo.png';
import LogoMaccaferri from '../../../app/images/LogoMaccaferri.svg';
import { useAppDispatch } from '../../../reduxService/hooks';
import { useNavigate } from 'react-router-dom';
import { cleanProjectInfo } from '../../store/projectInfo/projectInfoSlice';
import { endpoint } from '..';
import Button from '../../../components/Button/Button';
import { useTranslation } from 'react-i18next';

const PageNotFound = () => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const navigateAfterError = () => {
        dispatch(cleanProjectInfo());
        /*  dispatch(cleanProject()); */
        navigate(endpoint.home);
    };
    return (
        <header id="HeaderMacread">
            <div className="head">
                <div className="leftHead">
                    <img className="logoMacra" src={LogoMacRODesignNegative} alt="Maccaferri logo header" />
                    <span className="title">
                        <h5>{t('header_title')}</h5>
                    </span>
                </div>
                <a className="backToHub" href={process.env.REACT_APP_EDESIGN_PORTAL_URL}>
                    {t('header_back_to_hub')}
                </a>
                <button className="cursor-pointer logoMaccaferri" onClick={navigateAfterError} style={{ background: 'none', border: 'none', padding: 0 }} aria-label="Go to home">
                    <img src={LogoMaccaferri} alt="Logo Maccaferri" />
                </button>
            </div>
            <div className="error-boundary">
                <h1>{t('page_not_found')}</h1>
                <Button className="d-flex justify-content-end mb-3" onClick={navigateAfterError}>
                    {t('header_label_home')}
                </Button>
            </div>
        </header>
    );
};
export default PageNotFound;
